import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input, message, Cascader} from 'antd';
import { companyRegister, getVerification_code, getCompanyCategories } from '../../api/User';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useRef } from 'react';
import { useEffect } from 'react';

import { debounce } from 'lodash';
import { CustomInput, CustomInputTextarea } from '../../components/CustomForm';

const RegisterContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 184px);
  display: flex;
  justify-content: center;
  /* align-items: center; */
`;
const Content = styled.div`
  width: 470px;
`;
const Title = styled.h2`
  font-size: 32px;
  color: #fff;
  margin-bottom: 40px;
  // margin-top: 68px;
`;

const Tip = styled.div`
  width: 100%;
  text-align: left;
  padding-bottom: 20px;
`;
const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const Relative = styled.div`
  position: relative;
`

const style = {
  borderRadius: '4px',
  height: '50px',
};

const After = ({ setVerification_key, form }) => {
  const [state, setState] = useState(61);
  const Timer = useRef(null);

  const startTimer = () => {
    Timer.current = setInterval(() => {
      setState((prve) => prve - 1);
    }, 1000);
  };

  const sendVerificationCode = async () => {
    try {
      await form.validateFields(['contact_email'])
      const res = await getVerification_code({
        email: form.getFieldValue('contact_email'),
      });
      if (res && res.code === '10000' && res.data) {
        setVerification_key(res.data.key);
        message.success('Verification code has been sent');
        setState((prve) => prve - 1);
        startTimer();
      }
    } catch (err) {
      console.error(err)
    }
  };

  useEffect(() => {
    if (state <= 0 && Timer.current) {
      clearInterval(Timer.current);
      setState(61);
    }
  }, [state]);

  return (
    <div className="Verification-tips">
      {state >= 61 || state === 0 ? (
        <span
          onClick={debounce(sendVerificationCode, 5000, {
            leading: true,
            trailing: false,
          })}
        >
          Send Verification Code
        </span>
      ) : (
        <div className="second-tips">{state}s</div>
      )}
    </div>
  );
};

const CompanyRegister = () => {
  const { t } = useTranslation();

  const [form] = Form.useForm();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [verification_key, setVerification_key] = useState('');

  const [companyCategories, setCompanyCategories] = useState([]);

  // 获取报告等级数据
  const fetchCompanyCategories = async () => {
    try {
      const { code, data } = await getCompanyCategories();
      if (code === '10000') {
        setCompanyCategories(data);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  function filter(inputValue, path) {
    return path.some(option => option.name.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
  }

  // 获取厂商列表 分类数据
  useEffect(() => {
    fetchCompanyCategories();
  }, []);

  // 提交表单，注册
  const onFinish = async (values) => {
    const FormData = Object.assign(values, { verification_key });
    FormData.company_category_id=FormData.company_category_id[0];
    setLoading(true);
    const res = await companyRegister(FormData);

    if (res && res.code === '10000') {
      message.success('Registration success');
      // 成功后跳转验证界面
      navigate('/info/tips', {
        state: {
          message:
            'We have received your registration application, our staff will contact you within 5 working days, please pay attention to your contact information.',
        },
        replace: false,
      });
      form.resetFields();
    } else {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    message.error('validateField');
  };

  return (
    <RegisterContainer>
      <Content>
        <Title>{t('CompanyRegisterPage.title')}</Title>
        <Form
          form={form}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            name="name"
            hasFeedback
            rules={[{ required: true, message: 'Please input Project Name!' }]}
          >
            <CustomInput
              placeholder={t('CompanyRegisterPage.CompanyName')}
            />
          </Form.Item>

          <Form.Item
              name={'company_category_id'}
              rules={[
                {
                  required: true,
                  message: 'Please select the company category',
                },
              ]}
            >
              <Cascader
                allowClear={true}
                // open={true}
                placeholder={t('CompanyRegisterPage.companyCategory')}
                className={'add-report-select'}
                fieldNames={{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }}
                options={companyCategories}
                showSearch={{filter,matchInputWidth:true}}
              />
            </Form.Item>

          <Form.Item
            name="description"
            hasFeedback
            rules={[
              { required: true, message: 'Please input Project Description!' },
            ]}
          >
            <CustomInputTextarea
              autoSize={3}
              placeholder={t('CompanyRegisterPage.CompanyDescription')}
            />
          </Form.Item>

          <Form.Item
            name="contact_name"
            hasFeedback
            rules={[{ required: true, message: 'Please input Contact Name!' }]}
          >
            <CustomInput
              placeholder={t('CompanyRegisterPage.ContactName')}
            />
          </Form.Item>

          <Form.Item
            name="contact_mobile"
            hasFeedback
            // rules={[
            //   { required: true, message: 'Please input Contact Number!' },
            //   {
            //     type: 'mobile',
            //     message: 'The input is not valid mobile!',
            //   },
            // ]}
          >
            <CustomInput
              placeholder={t('CompanyRegisterPage.ContactNumber')}
            />
          </Form.Item>

          <Form.Item
            name="contact_email"
            hasFeedback
            rules={[
              { required: true, message: 'Please input Contact Email' },
              {
                type: 'email',
                message: 'The input is not valid email!',
              },
            ]}
          >
            <CustomInput
              placeholder={t('CompanyRegisterPage.ContactEmail')}
            />
          </Form.Item>

          <Relative>
            <Form.Item
                name="verification_code"
                hasFeedback
                rules={[
                  { required: true, message: 'Please input Verification Code' },
                ]}
            >
              {/* <Input.Group compact>
            <Input style={{ width: 'calc(100% - 200px)' }} defaultValue="https://ant.design" />
            <Button type="primary">Submit</Button>
          </Input.Group> */}
              <CustomInput
                  name="verification_code"
                  style={style}
                  className={'verification-code-container'}
                  placeholder={t('CompanyRegisterPage.VerificationCode')}
              />
            </Form.Item>
            <After setVerification_key={setVerification_key} form={form} />
          </Relative>

          <Form.Item
            name="official_site"
            hasFeedback
          >
            <CustomInput
              placeholder={t('CompanyRegisterPage.OfficialWebsite')}
            />
          </Form.Item>

          <Form.Item>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                style={{
                  height: '42px',
                  backgroundColor: '#18EAC4',
                  borderColor: '#18EAC4',
                  color: '#000',
                  borderRadius: '4px',
                }}
              >
                {t('CompanyRegisterPage.register')}
              </Button>
            </ButtonGroup>
          </Form.Item>
        </Form>
      </Content>
    </RegisterContainer>
  );
};

export default CompanyRegister;
